import { useEffect, useMemo, useState } from "react";
import { Box, Container, Typography } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useParams } from "react-router";
import { useAttackForgeApi, AttackForgeVuln } from "../hooks/AttackForgeHook";
import { Product, useProductApi } from "../hooks/ProductApiHook";

const AttackForgeIssuesPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const productApi = useProductApi();
  const [product, setProduct] = useState<Product>();
  const attackForgeApi = useAttackForgeApi();
  const [issues, setIssues] = useState<Array<AttackForgeVuln>>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const GetProduct = async () => {
    if (id) {
      try {
        const product = await productApi.GetProduct(id);
        setProduct(product);

      } catch (error) {
        console.log(error);
      }
    }
  }

  useEffect(() => {
    GetProduct();
  }, [id]);

  useEffect(() => {
    const load = async () => {
      if (!id) return;
      setIsLoading(true);
      try {
        const data = await attackForgeApi.GetIssues(id);
        setIssues(data || []);
      } catch (e) {
        console.error(e);
      } finally {
        setIsLoading(false);
      }
    };
    load();
  }, [id]);

  const rows = useMemo(
    () =>
      (issues || []).map((v) => ({
        id: v.id,
        vulnId: v.vulnID,
        projectId: v.projectId,
        title: v.title,
        severity: v.severity,
        status: v.status,
        assetName: v.assetName,
        created: v.created ? new Date(v.created).toLocaleString() : "",
        lastUpdate: v.lastUpdate ? new Date(v.lastUpdate).toLocaleString() : "",
      })),
    [issues]
  );

  const columns: GridColDef[] = [
    { field: "title", headerName: "Title", flex: 2, minWidth: 250 },
    { field: "severity", headerName: "Severity", flex: 1, minWidth: 110 },
    { field: "status", headerName: "Status", flex: 1, minWidth: 110 },
    { field: "created", headerName: "Created", flex: 1, minWidth: 160 },
    { field: "statusUpdated", headerName: "Status Updated", flex: 1, minWidth: 160 },
  ];

  return (
    <Container
      sx={{
        py: 2,
        display: "flex",
        flexDirection: "column",
        height: "100vh",
      }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        AttackForge Issues - {product != undefined && product.name}
      </Typography>
      <Box sx={{ flex: 1 }}>
        <DataGrid
          rows={rows}
          columns={columns}
          loading={isLoading}
          disableRowSelectionOnClick
          initialState={{
            pagination: { paginationModel: { pageSize: 25, page: 0 } },
          }}
          pageSizeOptions={[10, 25, 50, 100]}
        />
      </Box>
    </Container>
  );
};

export default AttackForgeIssuesPage;


